
// // // // // import React from 'react';
// // // // // import { Link } from 'react-router-dom';
// // // // // import Students from '../assets/students.svg';
// // // // // import { ArrowRightIcon } from '@heroicons/react/24/outline';

// // // // // const HeroSection = () => {
// // // // //   return (
// // // // //     <section className="text-white py-20 px-6 md:px-16">
// // // // //       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">
// // // // //         {/* Text Block */}
// // // // //         <div>
// // // // //           <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
// // // // //             Welcome to <span className="text-indigo-400">Isnartech</span> <br />
// // // // //             School ERP Solution
// // // // //           </h1>
// // // // //           <p className="text-gray-300 text-lg mb-8">
// // // // //             Empower your school with AI-driven ERP technology. Streamline daily operations, enhance learning experiences, and connect every stakeholder in one unified platform.
// // // // //           </p>

// // // // //           <div className="flex flex-col sm:flex-row gap-4">
// // // // //             <Link to="/registerSchool">
// // // // //               <button className="bg-indigo-500 hover:bg-indigo-600 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 transition-all duration-300">
// // // // //                 Start 365-Days Trial
// // // // //                 <ArrowRightIcon className="h-5 w-5" />
// // // // //               </button>
// // // // //             </Link>
// // // // //             <Link to="/features">
// // // // //               <button className="bg-gray-700 hover:bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold">
// // // // //                 Explore Features
// // // // //               </button>
// // // // //             </Link>
// // // // //           </div>
// // // // //         </div>

// // // // //         {/* Illustration */}
// // // // //         <div className="flex justify-center">
// // // // //           <img src={Students} alt="Students" className="max-w-[90%] md:max-w-full" />
// // // // //         </div>
// // // // //       </div>
// // // // //     </section>
// // // // //   );
// // // // // };

// // // // // export default HeroSection;


// // // // import React from 'react';
// // // // import { Link } from 'react-router-dom';
// // // // import HeroImage from '../assets/4.png'; // updated image import
// // // // import { ArrowRightIcon } from '@heroicons/react/24/outline';

// // // // const HeroSection = () => {
// // // //   return (
// // // //     <section className="relative text-white py-24 px-6 md:px-16 overflow-hidden">
// // // //       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center">

// // // //         {/* Text Block */}
// // // //         <div className="space-y-6">
// // // //           <h1 className="text-5xl md:text-6xl font-extrabold leading-tight tracking-tight">
// // // //             Welcome to <span className="text-indigo-400">Isnartech</span> <br /> 
// // // //             School ERP Solution
// // // //           </h1>

// // // //           <p className="text-gray-300 text-lg max-w-xl">
// // // //             Empower your school with AI-driven ERP technology. Streamline daily operations, enhance learning experiences, and connect every stakeholder in one unified platform.
// // // //           </p>

// // // //           <div className="flex flex-col sm:flex-row gap-5">
// // // //             <Link to="/registerSchool" className="group relative inline-flex items-center overflow-hidden rounded-lg bg-gradient-to-r from-indigo-500 to-indigo-700 px-8 py-3 font-semibold text-white shadow-lg hover:shadow-indigo-600 transition-shadow duration-300">
// // // //               <span className="relative z-10 flex items-center gap-2">
// // // //                 Start 365-Days Trial
// // // //                 <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" />
// // // //               </span>
// // // //               <span className="absolute inset-0 bg-indigo-600 opacity-20 blur-xl rounded-lg"></span>
// // // //             </Link>

// // // //             <Link to="/features" className="inline-block rounded-lg border border-gray-600 px-8 py-3 font-semibold text-gray-300 hover:text-white hover:border-indigo-400 transition-colors duration-300 text-center">
// // // //               Explore Features
// // // //             </Link>
// // // //           </div>
// // // //         </div>

// // // //         {/* Illustration */}
// // // //         <div className="flex justify-center md:justify-end">
// // // //           <img 
// // // //             src={HeroImage} 
// // // //             alt="School ERP Illustration" 
// // // //             className="max-w-full w-[90%] md:w-auto rounded-xl shadow-2xl transform hover:scale-105 transition-transform duration-500 ease-in-out"
// // // //             loading="lazy"
// // // //           />
// // // //         </div>
// // // //       </div>

// // // //       {/* Decorative floating circles for subtle interaction */}
// // // //       <div className="absolute top-10 left-10 w-32 h-32 bg-indigo-600 rounded-full opacity-20 animate-pulse mix-blend-soft-light pointer-events-none"></div>
// // // //       <div className="absolute bottom-20 right-20 w-48 h-48 bg-indigo-500 rounded-full opacity-10 animate-ping mix-blend-soft-light pointer-events-none"></div>
// // // //     </section>
// // // //   );
// // // // };

// // // // export default HeroSection;



// // // // import React from 'react';
// // // // import { Link } from 'react-router-dom';
// // // // import { ArrowRightIcon } from '@heroicons/react/24/outline';
// // // // import FeatureCarouselHero from './FeatureCarousel';

// // // // const HeroSection = () => {
// // // //   return (
// // // //     <section className="relative text-white py-24 px-6 md:px-16 overflow-hidden">
// // // //       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-10 items-center">

// // // //         {/* Text Block */}
// // // //         <div className="space-y-6">
// // // //           <h1 className="text-5xl md:text-6xl font-extrabold leading-tight tracking-tight">
// // // //             Welcome to <span className="text-indigo-400">Isnartech</span> <br />
// // // //             School ERP Solution
// // // //           </h1>

// // // //           <p className="text-gray-300 text-lg max-w-xl">
// // // //             Empower your school with AI-driven ERP technology. Streamline daily operations, enhance learning experiences, and connect every stakeholder in one unified platform.
// // // //           </p>

// // // //           <div className="flex flex-col sm:flex-row gap-5">
// // // //             <Link
// // // //               to="/registerSchool"
// // // //               className="group relative inline-flex items-center overflow-hidden rounded-lg bg-gradient-to-r from-indigo-500 to-indigo-700 px-8 py-3 font-semibold text-white shadow-lg hover:shadow-indigo-600 transition-shadow duration-300"
// // // //             >
// // // //               <span className="relative z-10 flex items-center gap-2">
// // // //                 Start 365-Days Trial
// // // //                 <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" />
// // // //               </span>
// // // //               <span className="absolute inset-0 bg-indigo-600 opacity-20 blur-xl rounded-lg"></span>
// // // //             </Link>

// // // //             <Link
// // // //               to="/features"
// // // //               className="inline-block rounded-lg border border-gray-600 px-8 py-3 font-semibold text-gray-300 hover:text-white hover:border-indigo-400 transition-colors duration-300 text-center"
// // // //             >
// // // //               Explore Features
// // // //             </Link>
// // // //           </div>
// // // //         </div>

// // // //         {/* Carousel in place of Image */}
// // // //         <div className="w-full max-w-[550px] mx-auto md:mx-0">
// // // //           <FeatureCarouselHero /> {/* 👇 Custom, smaller version of FeatureCarousel */}
// // // //         </div>
// // // //       </div>

// // // //       {/* Decorative floating circles */}
// // // //       <div className="absolute top-10 left-10 w-32 h-32 bg-indigo-600 rounded-full opacity-20 animate-pulse mix-blend-soft-light pointer-events-none"></div>
// // // //       <div className="absolute bottom-20 right-20 w-48 h-48 bg-indigo-500 rounded-full opacity-10 animate-ping mix-blend-soft-light pointer-events-none"></div>
// // // //     </section>
// // // //   );
// // // // };

// // // // export default HeroSection;

// // // import React from 'react';
// // // import { Link } from 'react-router-dom';
// // // import { ArrowRightIcon } from '@heroicons/react/24/outline';
// // // import FeatureCarouselHero from './FeatureCarousel'; // Assuming this is the compact version

// // // const HeroSection = () => {
// // //   return (
// // //     <section className="relative text-white py-24 px-6 md:px-16 overflow-hidden">
// // //       <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-16">

// // //         {/* Text Block */}
// // //         <div className="space-y-6">
// // //           <h1 className="text-5xl md:text-6xl font-extrabold tracking-tight leading-snug space-y-2">
// // //             <div>Welcome to</div>
// // //             <div className="text-indigo-400">Isnartech</div>
// // //             <div>School ERP Solution</div>
// // //           </h1>


// // //           <p className="text-gray-300 text-lg max-w-xl">
// // //             Empower your school with AI-driven ERP technology. Streamline daily operations, enhance learning experiences, and connect every stakeholder in one unified platform.
// // //           </p>

// // //           <div className="flex flex-col sm:flex-row gap-5">
// // //             <Link
// // //               to="/registerSchool"
// // //               className="group relative inline-flex items-center overflow-hidden rounded-lg bg-gradient-to-r from-indigo-500 to-indigo-700 px-8 py-3 font-semibold text-white shadow-lg hover:shadow-indigo-600 transition-shadow duration-300"
// // //             >
// // //               <span className="relative z-10 flex items-center gap-2">
// // //                 Start 90-Days Trial
// // //                 <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" />
// // //               </span>
// // //               <span className="absolute inset-0 bg-indigo-600 opacity-20 blur-xl rounded-lg"></span>
// // //             </Link>

// // //             <Link
// // //               to="/features"
// // //               className="inline-block rounded-lg border border-gray-600 px-8 py-3 font-semibold text-gray-300 hover:text-white hover:border-indigo-400 transition-colors duration-300 text-center"
// // //             >
// // //               Explore Features
// // //             </Link>
// // //           </div>
// // //         </div>

// // //         {/* 🎯 Enhanced Carousel Box */}
// // //         <div className="w-full max-w-[450px] mx-auto md:mx-0">
// // //           <div className="aspect-square rounded-2xl border border-indigo-500/30 shadow-2xl overflow-hidden bg-gradient-to-br from-slate-900 to-slate-800 backdrop-blur-md p-2">
// // //             <FeatureCarouselHero />
// // //           </div>
// // //         </div>
// // //       </div>

// // //       {/* Decorative floating circles */}
// // //       <div className="absolute top-10 left-10 w-32 h-32 bg-indigo-600 rounded-full opacity-20 animate-pulse mix-blend-soft-light pointer-events-none"></div>
// // //       <div className="absolute bottom-20 right-20 w-48 h-48 bg-indigo-500 rounded-full opacity-10 animate-ping mix-blend-soft-light pointer-events-none"></div>
// // //     </section>
// // //   );
// // // };

// // // export default HeroSection;

// // import React from 'react';
// // import { Link } from 'react-router-dom';
// // import { ArrowRightIcon } from '@heroicons/react/24/outline';

// // const chips = [
// //   { label: 'Attendance, done in a tap', style: 'top-[18%] -left-6 md:-left-10' },
// //   { label: 'Fees & payroll, tracked automatically', style: 'top-[46%] -right-6 md:-right-12' },
// //   { label: 'Report cards, generated instantly', style: 'bottom-[10%] -left-4 md:-left-8' },
// // ];

// // const GrowthGraphic = () => (
// //   <div className="relative w-full aspect-square">
// //     <style>{`
// //       @keyframes growBar { from { transform: scaleY(0); } to { transform: scaleY(1); } }
// //       @keyframes floatChip {
// //         0%, 100% { transform: translateY(0px); }
// //         50% { transform: translateY(-6px); }
// //       }
// //       .bar { transform-origin: bottom; animation: growBar 1.1s cubic-bezier(.22,1,.36,1) both; }
// //       .chip { animation: floatChip 4s ease-in-out infinite; }
// //     `}</style>
// //     <svg viewBox="0 0 400 400" className="w-full h-full">
// //       <path d="M40 210 L110 140 L150 178 L230 90" fill="none" stroke="#E8A63C" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
// //       <circle cx="230" cy="90" r="9" fill="#E8A63C" />
// //       <rect className="bar" x="70" y="230" width="52" height="120" rx="10" fill="#DCE8F7" style={{ animationDelay: '0.1s' }} />
// //       <rect className="bar" x="174" y="170" width="52" height="180" rx="10" fill="#2E63B8" style={{ animationDelay: '0.28s' }} />
// //       <rect className="bar" x="278" y="110" width="52" height="240" rx="10" fill="#163863" style={{ animationDelay: '0.46s' }} />
// //     </svg>

// //     {chips.map((c, i) => (
// //       <div
// //         key={c.label}
// //         className={`chip hidden sm:block absolute ${c.style} bg-white border border-[#E3E8F0] shadow-[0_10px_30px_-16px_rgba(16,24,38,0.35)] rounded-xl px-4 py-2.5 max-w-[190px]`}
// //         style={{ animationDelay: `${i * 0.6}s` }}
// //       >
// //         <p className="text-[13px] font-['Sora',sans-serif] font-medium text-[#163863] leading-snug">{c.label}</p>
// //       </div>
// //     ))}
// //   </div>
// // );

// // const HeroSection = () => {
// //   return (
// //     <section className="relative py-16 md:py-24 px-6 md:px-16 overflow-hidden">
// //       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">
// //         <div className="space-y-7">
// //           <h1 className="font-['Fraunces',serif] text-[2.75rem] md:text-6xl leading-[1.08] tracking-tight text-[#101826]">
// //             The school ERP built to grow with you.
// //           </h1>

// //           <p className="text-[#5A6478] font-['Sora',sans-serif] text-lg max-w-lg leading-relaxed">
// //             Eduvantra brings admissions, attendance, fees, communication and
// //             analytics into one platform — so your school runs on one system
// //             instead of five.
// //           </p>

// //           <div className="flex flex-col sm:flex-row gap-4 pt-2">
// //             <Link
// //               to="/registerSchool"
// //               className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#163863] px-8 py-3.5 font-['Sora',sans-serif] font-semibold text-white transition-colors duration-200 hover:bg-[#2E63B8]"
// //             >
// //               Start your 90-day trial
// //               <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" />
// //             </Link>

// //             <Link
// //               to="/features"
// //               className="inline-flex items-center justify-center rounded-full border border-[#D8DEE9] px-8 py-3.5 font-['Sora',sans-serif] font-semibold text-[#163863] hover:border-[#2E63B8] hover:text-[#2E63B8] transition-colors duration-200"
// //             >
// //               See what's included
// //             </Link>
// //           </div>

// //           <p className="text-sm text-[#8891A0] font-['Sora',sans-serif] pt-1">
// //             No card required — set up your first class in minutes.
// //           </p>
// //         </div>

// //         <div className="w-full max-w-[440px] mx-auto md:mx-0 md:ml-auto">
// //           <GrowthGraphic />
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default HeroSection;


// import React from 'react';
// import { Link } from 'react-router-dom';
// import { ArrowRightIcon } from '@heroicons/react/24/outline';

// const chips = [
//   { label: 'Attendance, done in a tap', style: 'top-[18%] left-0 sm:-left-4 md:-left-10' },
//   { label: 'Fees & payroll, tracked automatically', style: 'top-[46%] right-0 sm:-right-4 md:-right-12' },
//   { label: 'Report cards, generated instantly', style: 'bottom-[10%] left-0 sm:-left-2 md:-left-8' },
// ];

// const GrowthGraphic = () => (
//   <div className="relative w-full aspect-square overflow-visible">
//     <style>{`
//       @keyframes growBar { from { transform: scaleY(0); } to { transform: scaleY(1); } }
//       @keyframes floatChip {
//         0%, 100% { transform: translateY(0px); }
//         50% { transform: translateY(-6px); }
//       }
//       .bar { transform-origin: bottom; animation: growBar 1.1s cubic-bezier(.22,1,.36,1) both; }
//       .chip { animation: floatChip 4s ease-in-out infinite; }
//     `}</style>
//     <svg viewBox="0 0 400 400" className="w-full h-full">
//       <path d="M40 210 L110 140 L150 178 L230 90" fill="none" stroke="#E8A63C" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
//       <circle cx="230" cy="90" r="9" fill="#E8A63C" />
//       <rect className="bar" x="70" y="230" width="52" height="120" rx="10" fill="#DCE8F7" style={{ animationDelay: '0.1s' }} />
//       <rect className="bar" x="174" y="170" width="52" height="180" rx="10" fill="#2E63B8" style={{ animationDelay: '0.28s' }} />
//       <rect className="bar" x="278" y="110" width="52" height="240" rx="10" fill="#163863" style={{ animationDelay: '0.46s' }} />
//     </svg>

//     {chips.map((c, i) => (
//       <div
//         key={c.label}
//         className={`chip hidden sm:block absolute ${c.style} bg-white border border-[#E3E8F0] shadow-[0_10px_30px_-16px_rgba(16,24,38,0.35)] rounded-xl px-4 py-2.5 max-w-[190px]`}
//         style={{ animationDelay: `${i * 0.6}s` }}
//       >
//         <p className="text-[13px] font-['Sora',sans-serif] font-medium text-[#163863] leading-snug">{c.label}</p>
//       </div>
//     ))}
//   </div>
// );

// const HeroSection = () => {
//   return (
//     <section className="relative py-16 md:py-24 px-6 md:px-16 overflow-hidden">
//       <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">
//         <div className="space-y-7">
//           <h1 className="font-['Fraunces',serif] text-[2.75rem] md:text-6xl leading-[1.08] tracking-tight text-[#101826]">
//             The school ERP built to grow with you.
//           </h1>

//           <p className="text-[#5A6478] font-['Sora',sans-serif] text-lg max-w-lg leading-relaxed">
//             Eduvantra brings admissions, attendance, fees, communication and
//             analytics into one platform — so your school runs on one system
//             instead of five.
//           </p>

//           <div className="flex flex-col sm:flex-row gap-4 pt-2">
//             <Link
//               to="/registerSchool"
//               className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#163863] px-8 py-3.5 font-['Sora',sans-serif] font-semibold text-white transition-colors duration-200 hover:bg-[#2E63B8]"
//             >
//               Start your 90-day trial
//               <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" />
//             </Link>

//             <Link
//               to="/#features"
//               className="inline-flex items-center justify-center rounded-full border border-[#D8DEE9] px-8 py-3.5 font-['Sora',sans-serif] font-semibold text-[#163863] hover:border-[#2E63B8] hover:text-[#2E63B8] transition-colors duration-200"
//             >
//               See what's included
//             </Link>
//           </div>

//           <p className="text-sm text-[#8891A0] font-['Sora',sans-serif] pt-1">
//             No card required — set up your first class in minutes.
//           </p>
//         </div>

//         <div className="w-full max-w-[440px] mx-auto md:mx-0 md:ml-auto">
//           <GrowthGraphic />
//         </div>
//       </div>
//     </section>
//   );
// };

// export default HeroSection;


import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';

const chips = [
  { label: 'Attendance, done in a tap', style: 'top-[18%] left-0 sm:-left-4 md:-left-10' },
  { label: 'Fees & payroll, tracked automatically', style: 'top-[46%] right-0 sm:-right-4 md:-right-12' },
  { label: 'Report cards, generated instantly', style: 'bottom-[10%] left-0 sm:-left-2 md:-left-8' },
];

const GrowthGraphic = () => (
  <div className="relative w-full aspect-square overflow-visible">
    <style>{`
      @keyframes growBar { from { transform: scaleY(0); } to { transform: scaleY(1); } }
      @keyframes floatChip {
        0%, 100% { transform: translateY(0px); }
        50% { transform: translateY(-6px); }
      }
      .bar { transform-origin: bottom; animation: growBar 1.1s cubic-bezier(.22,1,.36,1) both; }
      .chip { animation: floatChip 4s ease-in-out infinite; }
    `}</style>
    <svg viewBox="0 0 400 400" className="w-full h-full">
      <path d="M40 210 L110 140 L150 178 L230 90" fill="none" stroke="#E8A63C" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="230" cy="90" r="9" fill="#E8A63C" />
      <rect className="bar" x="70" y="230" width="52" height="120" rx="10" fill="#DCE8F7" style={{ animationDelay: '0.1s' }} />
      <rect className="bar" x="174" y="170" width="52" height="180" rx="10" fill="#2E63B8" style={{ animationDelay: '0.28s' }} />
      <rect className="bar" x="278" y="110" width="52" height="240" rx="10" fill="#163863" style={{ animationDelay: '0.46s' }} />
    </svg>

    {chips.map((c, i) => (
      <div
        key={c.label}
        className={`chip hidden sm:block absolute ${c.style} bg-white border border-[#E3E8F0] shadow-[0_10px_30px_-16px_rgba(16,24,38,0.35)] rounded-xl px-4 py-2.5 max-w-[190px]`}
        style={{ animationDelay: `${i * 0.6}s` }}
      >
        <p className="text-[13px] font-medium text-[#163863] leading-snug" style={{ fontFamily: "'Sora', sans-serif" }}>
          {c.label}
        </p>
      </div>
    ))}
  </div>
);

const HeroSection = () => {
  return (
    <section className="relative py-16 md:py-24 px-6 md:px-16 overflow-hidden" style={{ fontFamily: "'Sora', sans-serif" }}>
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center">
        <div className="space-y-7">
          <h1 style={{ fontFamily: "'Fraunces', serif" }} className="text-[2.75rem] md:text-6xl leading-[1.08] tracking-tight text-[#101826]">
            The school ERP built to grow with you.
          </h1>

          <p className="text-[#5A6478] text-lg max-w-lg leading-relaxed">
            Eduvantra brings admissions, attendance, fees, communication and
            analytics into one platform — so your school runs on one system
            instead of five.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 pt-2">
            <Link
              to="/registerSchool"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#163863] px-6 py-2.5 text-[15px] font-semibold text-white transition-colors duration-200 hover:bg-[#2E63B8]"
            >
              Start your 90-day trial
              <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>

            <Link
              to="/#find-school"
              className="inline-flex items-center justify-center gap-2 rounded-full border border-[#D8DEE9] px-6 py-2.5 text-[15px] font-semibold text-[#163863] hover:border-[#2E63B8] hover:text-[#2E63B8] transition-colors duration-200"
            >
              <MagnifyingGlassIcon className="h-4 w-4" />
              Find your school
            </Link>
          </div>

          <p className="text-sm text-[#8891A0] pt-1">
            No card required — set up your first class in minutes.
          </p>
        </div>

        <div className="w-full max-w-[440px] mx-auto md:mx-0 md:ml-auto">
          <GrowthGraphic />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
